import React from "react";

const buttonContentStyle = { fontSize: "1rem", fontWeight: 500 };
export const buttonContent = (content) => (
  <div style={buttonContentStyle}>{content}</div>
);
